import { Switch } from "@progress/kendo-react-inputs";

function HyperlinkCell({ dataItem, hidden, pages, onChange }) {

    function handleChange(event) {
        onChange(event, dataItem);
    }

    return (
        <td>
            <Switch
                disabled={
                    (
                        hidden ||
                        dataItem.attributeType === "Phone" ||
                        dataItem.attributeType === "Html" ||
                        dataItem.attributeType === "TreePath" ||
                        dataItem.attributeType === "Image"
                    ) ||
                    pages.length === 0
                }
                onChange={handleChange}
                checked={dataItem.hyperlink} />
        </td>
    )
}

export default HyperlinkCell;